import { isAppControl, loginSilently } from "@newsenec/auth-provider";
import { changeLoginState } from "./flow";
import { getCockpitUserAuthState, getControlUserAuthState, isEmailVerified } from "./authorization";

export function startLogin() {
    console.log("location to store: ", location.href);
    isAppControl() ? startControlLogin() : startCockpitLogin();
}

function startCockpitLogin() {
    loginSilently()
        .then((user) => {
            if (!user) throw new Error("Could not retrieve user");
            if (!isEmailVerified(user)) return changeLoginState("emailNotVerified");
            changeLoginState(getCockpitUserAuthState(user));
        })
        .catch((error) => {
            console.info(error);
            changeLoginState("loginFailed");
        });
}

function startControlLogin() {
    loginSilently()
        .then((user) => {
            if (!user) throw new Error("Could not retrieve user");
            changeLoginState(getControlUserAuthState(user));
        })
        .catch((error) => {
            console.info(error);
            changeLoginState("loginFailed");
        });
}
